import icon1 from '../images/icon/research.gif'
import icon2 from '../images/icon/durability.gif'
import icon3 from '../images/icon/digital-tra.gif'
import icon4 from '../images/icon/business-develop.gif'
import icon5 from '../images/icon/search.gif'
import icon6 from '../images/icon/warning.gif'

import sicon1 from '../images/icon/ser-icon01.svg'
import sicon2 from '../images/icon/ser-icon02.svg'
import sicon3 from '../images/icon/ser-icon03.svg'
import sicon4 from '../images/icon/ser-icon04.svg'

import sdicon1 from '../images/icon/da-fea_icon01.svg'
import sdicon2 from '../images/icon/da-fea_icon02.svg'
import sdicon3 from '../images/icon/da-fea_icon03.svg'
import sdicon4 from '../images/icon/da-fea_icon04.svg'

import simg1 from '../images/service/service-img02.jpg'
import simg2 from '../images/service/service-img01.jpg'
import simg3 from '../images/service/service-img03.jpg'
import simg4 from '../images/service/service-img04.jpg'


import scicon1 from '../images/icon/airdrop-white.svg'
import scicon2 from '../images/icon/cloud-add.svg'
import scicon3 from '../images/icon/check02.svg'
import scicon4 from '../images/icon/finger-scan.svg'
import scicon5 from '../images/icon/ranking.svg'


import cdicon1 from '../images/icon/cd-ser_icon01.svg'
import cdicon2 from '../images/icon/cd-ser_icon02.svg'
import cdicon3 from '../images/icon/cd-ser_icon03.svg'
import cdicon4 from '../images/icon/cd-ser_icon04.svg'
import cdicon5 from '../images/icon/cd-ser_icon05.svg'
import cdicon6 from '../images/icon/cd-ser_icon06.svg'
import cdicon7 from '../images/icon/cd-ser_icon08.svg'
import cdicon8 from '../images/icon/cd-ser_icon09.svg'



const Services = [
    {
        Id: 44,
        sImg: icon1,
        title: "%",
        slug: 'analyse',
        thumb1: 'Strategy',
        thumb2: 'Consultation',
        description: 'of all cyber incidents in the UK start with phishing, making the human element your primary attack vector.',
    },
    {
        Id: 1.6,
        sImg: icon2,
        title: 'B+',
        slug: 'analyse',
        thumb1: 'Management',
        thumb2: 'Transfer',
        description: 'records were exposed globally in 2023 due to cloud misconfigurations, a leading cause of data breaches.',
    },
    {
        Id: 1265,
        sImg: icon3,
        title: '%',
        slug: 'analyse',
        thumb1: 'Landing Page',
        thumb2: 'Plugins',
        description: 'increase in malicious phishing emails using Generative AI to hide code and evade traditional security scanners.',
    },

    {
        Id: 20,
        sImg: icon4,
        title1: ' $',
        title: ' M',
        slug: 'govern',
        thumb1: 'Consultation',
        thumb2: 'solution',
        description: 'or 4% of annual turnover. The potential fine for non-compliance with GDPR, making data protection a critical financial risk.',
    },
    {
        Id: 88,
        sImg: icon5,
        title: '%',
        slug: 'govern',
        thumb1: 'Website',
        thumb2: 'Mobile App',
        description: 'of board members now view cybersecurity as a business risk, demanding clear reporting and a mature governance strategy.',
    },
    {
        Id: 38,
        sImg: icon6,
        title: '%',
        slug: 'insure',
        description: 'average increase in cyber insurance premiums for UK organisations at their last renewal, rewarding those who can prove their resilience.',
    },
    {
        Id: 47,
        sImg: simg1,
        sIcon: sicon1,
        title: '%',
        slug: 'insure',
        description:'of organisations report that insurers now require more extensive information, demanding concrete evidence of strong security controls.',
    },
    {
        Id: 4.45,
        sImg: simg2,
         title1: ' $',
        sIcon: sicon2,
        title: 'M',
        slug: 'defend',
         description:'is the all-time high global average cost of a data breach, including fines, fees, and reputational damage.',
    },
    {
        Id: 277,
        sImg: simg3,
        sIcon: sicon3,
        title: 'Days',
        slug: 'defend',
          description:'is the average time to identify and contain a breach. The longer an attacker dwells, the greater the damage.',
    },
     {
        Id: 1.49,
        sImg: simg2,
         title1: ' $',
        sIcon: sicon2,
        title: 'M',
        slug: 'defend',
         description:'is the average saving for organisations with a tested incident response plan—the single biggest cost-saving factor.',
    },
    {
        Id: 1.49,
        sImg: simg4,
        sIcon: sicon4,
        title: 'Website development ',
        slug: 'Website-development ',
    },
    {
        Id: '11',
        sIcon: sdicon1,
        title: 'Data source identification',
        slug: 'Data-source',
        description: 'We identify the new and existing data sources that can help drive your business forward.',
    },
    {
        Id: '12',
        sIcon: sdicon2,
        title: 'Data ecosystem set up',
        slug: 'Data-ecosystem',
        description: 'We ingest your data into a data warehouse and set up your analytics to start making sense of it.',
    },
    {
        Id: '13',
        sIcon: sdicon3,
        title: 'AI solution Design',
        slug: 'AI-solution',
        description: 'We design AI solutions that use your newly found insights to identify new opportunities for improvement.',
    },
    {
        Id: '14',
        sIcon: sdicon4,
        title: 'Business-wide adoption',
        slug: 'Business-wide',
        description: 'We support you in helping your business understand, embrace, and adopt the change.',
    },
    {
        Id: '15',
        sIcon: scicon1,
        title: 'Secure your network',
        slug: 'Secure-your-network',
        features: [' Consistently Secure the Enterprise.', 'Apply Al inline to prevent evasive.', 'Simplify network security operations.', ' Adopt Zero Trust across the network.', ' Simplify with AI-Powered SASE.']
    },
    {
        Id: '16',
        sIcon: scicon2,
        title: 'Secure your cloud',
        slug: 'Secure-your-cloud',
        features: ['End-to-End Cloud Security.', 'Real-Time Threat Detection.', 'Identity & Access Management.', 'Data Encryption & Privacy.', 'Compliance & Governance.']
    },
    {
        id: '17',
        sIcon: scicon3,
        title: 'Transform your SOC',
        slug: 'Transform-your-SOC',
        features: [
            'Accelerate Threat Detection',
            'Automate Security Processes',
            'Streamline Incident Response',
            'Attack Surface Management',
            'Integrated Security Monitoring',
        ],
    },
    {
        id: '18',
        sIcon: scicon4,
        title: 'Threat Intel & Response',
        slug: 'Threat-Intel-&-Response',
        features: [
            "Let our experts be of your team.",
            "Move from reactive to proactive.",
            "Get world-class threat intelligence",
            "Every second counts when attack",
            "Make our experience your experience",
        ],
    },
    {
        id: '19',
        sIcon: scicon5,
        title: 'Solutions by industry',
        slug: 'Solutions-by-industry',
        features: [
            'Public sector',
            'Financial services',
            'Manufacturing',
            'Small & medium business solutions',
            'Healthcare',
        ],
    },

    {
        Id: '20',
        sIcon: cdicon1,
        title: 'INFRASTRUCT URE DESIGN',
        slug: 'INFRASTRUCT-URE-DESIGN',
    },
    {
        Id: '21',
        sIcon: cdicon2,
        title: 'COSTS OPTIMIZATION',
        slug: 'COSTS-OPTIMIZATION',
        bgClass:'cd-dot_bg2',
    },
    {
        Id: '22',
        sIcon: cdicon3,
        title: 'INFRASTRUCTURE AS A CODE',
        slug: 'INFRASTRUCTURE-AS-A-CODE',
        bgClass:'cd-dot_bg3',
    },
    {
        Id: '23',
        sIcon: cdicon4,
        title: 'Continuous Integration',
        slug: 'Continuous-Integration',
        bgClass:'cd-dot_bg4',
    },
    {
        Id: '24',
        sIcon: cdicon5,
        title: 'Continuous Deployment',
        slug: 'Continuous-Deployment',
    },
    {
        Id: '25',
        sIcon: cdicon6,
        title: 'Blue Green Deployment',
        slug: 'Blue-Green-Deployment',
        bgClass:'cd-dot_bg2',
    },
    {
        Id: '26',
        sIcon: '',
        title: 'Data Consistency',
        slug: 'Data-Consistency',
        bgClass:'cd-dot_bg3'
    },
    {
        Id: '27',
        sIcon: cdicon7,
        title: 'Data Integrity',
        slug: 'Data-Integrity',
        bgClass:'cd-dot_bg4'
    },
    {
        Id: '28',
        sIcon: cdicon8,
        title: 'Redundancy',
        slug: 'Redundancy',
    },
]

export default Services;